@if (!isMobile && (isViewingSharedProject() | async) === false) {
  <div class="wrapperAddedLoads">
    <div class="loadsOptions">
      <div class="label" data-ctx="label-added-loads">{{ 'added_loads' | translate }}</div>
      @if (!isProjectEmpty() && showAlgorithmSettings()) {
        <div class="algorithmSettings" (click)="loadsOptionsActive()" data-ctx="loads-option">
          <span>{{ 'algorithm_settings' | translate }}:</span>
          <gl-icon name="options" class="optionsIcon"></gl-icon>
        </div>
      }
    </div>
    @if (!isProjectEmpty() && isLoadsOptionsActive && showAlgorithmSettings()) {
      <div class="arrangement" @height>
        <div class="arrangementHeader">{{ 'way_of_stacking_loads' | translate }}:</div>
        @if (showRecommendations) {
          <div class="buttonWrapper">
            <gl-slide-toggle
              [ngModel]="calculateRecommendations"
              (ngModelChange)="recommendationsToggleHandler(true)"
              >
              {{ 'calculate_recommendations' | translate }}
            </gl-slide-toggle>
          </div>
        }
        <div class="buttonWrapper">
          <gl-radio-button
            name="arrangeOptimally"
            class="radioButton"
            [defaultChecked]="orderByArrangeOptimally"
            [ngModel]="orderByArrangeOptimally"
            (ngModelChange)="onOrderChange('orderByArrangeOptimally')"
            >{{ 'order_arrange_optimally' | translate }}
            </gl-radio-button
            >
            <div class="info" [glTooltip]="'order_arrange_optimally_info'" [width]="'300px'">i</div>
          </div>
          @if (orderByArrangeOptimally && project.workSpaces.length > 1) {
            <div class="buttonWrapper">
              <gl-checkbox
                [disabled]="isAllOptimizationDisabled"
                [defaultChecked]="allOptimization"
                [ngModel]="allOptimization"
                (ngModelChange)="onAllOptimization()"
                >{{ 'all_optimization' | translate }}</gl-checkbox
                >
                <div class="info" [glTooltip]="'all_optimization_info'" [width]="'300px'">i</div>
              </div>
            }
            <div class="buttonWrapper">
              <gl-radio-button
                class="radioButton"
                [defaultChecked]="orderByLoadsList"
                [ngModel]="orderByLoadsList"
                (ngModelChange)="onOrderChange('orderByLoadsList')"
                >{{ 'order_loads_list' | translate }}
                </gl-radio-button
                >
                <div class="info" [glTooltip]="'order_loads_list_info'" [width]="'300px'">i</div>
              </div>
              <div class="buttonWrapper">
                <gl-radio-button
                  class="radioButton"
                  [defaultChecked]="orderByLoadsVolume"
                  [ngModel]="orderByLoadsVolume"
                  (ngModelChange)="onOrderChange('orderByLoadsVolume')"
                  >{{ 'order_loads_volume' | translate }}
                  </gl-radio-button
                  >
                  <div class="info" [glTooltip]="'order_loads_volume_info'" [width]="'300px'">i</div>
                </div>
                <div class="buttonWrapper">
                  <gl-radio-button
                    class="radioButton"
                    [defaultChecked]="orderByLoadsWeight"
                    [ngModel]="orderByLoadsWeight"
                    (ngModelChange)="onOrderChange('orderByLoadsWeight')"
                    >{{ 'order_loads_weight' | translate }}
                    </gl-radio-button
                    >
                    <div class="info" [glTooltip]="'order_loads_weight_info'" [width]="'300px'">i</div>
                  </div>
                  <div class="buttonWrapper">
                    <gl-checkbox
                      [defaultChecked]="notOverLimit"
                      [ngModel]="notOverLimit"
                      (ngModelChange)="onNotOverLimitChange($event)"
                      >{{ 'consider_loading_space_limit' | translate }}
                      </gl-checkbox
                      >
                      <div class="info" [glTooltip]="'consider_loading_space_limit_info'" [width]="'300px'">i</div>
                    </div>
                    <div class="buttonWrapper">
                      <gl-checkbox
                        [disabled]="isSimpleAlgorithmDisabled"
                        [defaultChecked]="simpleAlgorithm"
                        [(ngModel)]="simpleAlgorithm"
                        (ngModelChange)="simpleAlgorithmChange($event)"
                        >{{ 'simple_algorithm' | translate }}
                        </gl-checkbox
                        >
                        <div class="info" [glTooltip]="'simple_algorithm_info'" [width]="'300px'">i</div>
                      </div>
                    </div>
                  }
                </div>
              }

              <ng-template
                #palletLayerGroupsTpl
                let-wsIndex="wsIndex"
                let-csIndex="csIndex"
                let-stopIndex="stopIndex"
                let-cargoSpace="cargoSpace"
                let-lastGroupInList="lastGroupInList"
              >
                @if (showPalletLayerGroupsInList(cargoSpace)) {
                  @for (
                    palletGroup of getPalletLayerGroups(cargoSpace);
                    track palletGroup.id;
                    let pgLast = $last
                  ) {
                    <gl-loads-list-pallet-layer-group
                      [palletGroup]="palletGroup"
                      [workSpaceIndex]="wsIndex"
                      [cargoSpaceIndex]="csIndex"
                      [stopIndex]="stopIndex"
                      [isSharedProjectLast]="isSharedProjectLast"
                      [lastInList]="lastGroupInList && pgLast"
                    />
                  }
                }
              </ng-template>

              <div data-ctx="workSpaces" class="workSpaces" [class.workSpacesMobile]="isMobile" #list cdkDropListGroup>
                @for (displayed of displayedWorkSpaces; track trackByDisplayedWorkSpace(displayed)) {
                  @let workSpace = displayed.workSpace;
                  @let i = displayed.index;
                  <div
                    class="workSpace"
                    [class.workSpaceActive]="checkIsWorkSpaceActive(displayed)"
                    >
                    <div class="cargoSpaces">
                      <gl-loading-space-element
                        class="draggable drag-disabled"
                        [class.draggable]="isClose(i) && !isMobile"
                        [workSpace]="workSpace"
                        [workSpaceIndex]="i"
                        [cargoSpaceIndex]="0"
                        [isClosed]="isClose(i)"
                        [palletQuantity]="displayed.quantity"
                        (showLoads)="showLoads($event)"
                        (palletQuantityChange)="onPalletQuantityChange(displayed, $event)"
                      ></gl-loading-space-element>
                      @if (!isClose(i) && !isStop(workSpace)) {
                        <div class="all-lists">
                          <div>
                            <div
                              cdkDropList
                              class="list"
                              [class.cargoListHidden]="isCargoSpaceDropListHidden(workSpace.cargoSpaces[0])"
                              [cdkDropListData]="cargoSpaceGroups(workSpace.cargoSpaces[0])"
                              [cdkDropListDisabled]="isDragDisabledForCargoSpace(workSpace.cargoSpaces[0])"
                              (cdkDropListDropped)="onDropped($event)"
                              [attr.data-work-space-index]="i"
                              [attr.data-cargo-space-index]="0"
                              >
                                <ng-container
                                  *ngTemplateOutlet="
                                    palletLayerGroupsTpl;
                                    context: {
                                      wsIndex: i,
                                      csIndex: 0,
                                      stopIndex: undefined,
                                      cargoSpace: workSpace.cargoSpaces[0],
                                      lastGroupInList: listGroupsForCargoSpace(workSpace.cargoSpaces[0]).length === 0
                                    }
                                  "
                                ></ng-container>
                                @for (
                                  group of listGroupsForCargoSpace(workSpace.cargoSpaces[0]); track trackByFunction(groupIndexSemiTrailer,
                                  group); let groupIndexSemiTrailer = $index) {
                                  <gl-loads-list-element
                                    cdkDrag
                                    [cdkDragDisabled]="isGroupDragDisabled(workSpace.cargoSpaces[0])"
                                    (cdkDragStarted)="onDragStarted($event)"
                                    (cdkDragEnded)="onDragEnded()"
                                    [class.draggable]="isGroupDraggable(workSpace.cargoSpaces[0])"
                                    (editwindow)="onEditWindow($event)"
                                    [group]="group"
                                    [isSharedProjectLast]="isSharedProjectLast"
                                    [workSpaceIndex]="i"
                                    [cargoSpaceIndex]="0"
                                    [lastLoad]="groupIndexSemiTrailer === listGroupsForCargoSpace(workSpace.cargoSpaces[0]).length - 1"
                                  ></gl-loads-list-element>
                                }
                              </div>
                            </div>
                          @if (workSpace.cargoSpaces[1]) {
                            <div>
                              <gl-loading-space-element
                                [workSpace]="workSpace"
                                [workSpaceIndex]="i"
                                [cargoSpaceIndex]="1"
                                [isClosed]="isClose(i)"
                                (showLoads)="showLoads($event)"
                              ></gl-loading-space-element>
                              <div
                                cdkDropList
                                [cdkDropListData]="cargoSpaceGroups(workSpace.cargoSpaces[1])"
                                [cdkDropListDisabled]="isDragDisabledForCargoSpace(workSpace.cargoSpaces[1])"
                                (cdkDropListDropped)="onDropped($event)"
                                [attr.data-work-space-index]="i"
                                [attr.data-cargo-space-index]="1"
                                class="list"
                                >
                                <ng-container
                                  *ngTemplateOutlet="
                                    palletLayerGroupsTpl;
                                    context: {
                                      wsIndex: i,
                                      csIndex: 1,
                                      stopIndex: undefined,
                                      cargoSpace: workSpace.cargoSpaces[1],
                                      lastGroupInList: listGroupsForCargoSpace(workSpace.cargoSpaces[1]).length === 0
                                    }
                                  "
                                ></ng-container>
                                @for (
                                  group of listGroupsForCargoSpace(workSpace.cargoSpaces[1]); track trackByFunction(groupIndexTrailer,
                                  group); let groupIndexTrailer = $index) {
                                  <gl-loads-list-element
                                    cdkDrag
                                    [cdkDragDisabled]="isGroupDragDisabled(workSpace.cargoSpaces[1])"
                                    (cdkDragStarted)="onDragStarted($event)"
                                    (cdkDragEnded)="onDragEnded()"
                                    [class.draggable]="isGroupDraggable(workSpace.cargoSpaces[1])"
                                    (editwindow)="onEditWindow($event)"
                                    [group]="group"
                                    [isSharedProjectLast]="isSharedProjectLast"
                                    [workSpaceIndex]="i"
                                    [cargoSpaceIndex]="1"
                                    [lastLoad]="groupIndexTrailer === listGroupsForCargoSpace(workSpace.cargoSpaces[1]).length - 1"
                                  ></gl-loads-list-element>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                      <!-- MULTISTOPS -->
                      @if (!isClose(i) && isStop(workSpace)) {
                        <div class="all-lists">
                          @for (
                            stop of workSpace.stops; track trackByFunctionWorkSpace(stopIndex,
                            stop); let stopIndex = $index) {
                            <div
                              [class.activeStop]="currentDisplayIndex === null && currentStopIndex === stopIndex || currentDisplayIndex === stopIndex"
                              >
                              <div data-ctx="multiStopTitle" class="multistopTitle" (click)="changeStop(i, stopIndex, $event)">
                                <div class="multistopLetter">{{ getStopLetterFromIndex(stopIndex) }}</div>
                                <div class="multistopName">{{ stop.name }}</div>
                              </div>
                              <div class="multistopLoads">
                                <div class="loadsTitle" data-ctx="loadsTitle">
                                  <gl-icon class="arrowIcon" name="arrow"></gl-icon>
                                  <div>{{ 'loads_cargo_loaded' | translate }}:</div>
                                </div>
                                <div data-ctx="loadsList">
                                    <div
                                      cdkDropList
                                      class="list"
                                      [class.cargoListHidden]="isCargoSpaceDropListHidden(stop.cargoSpaces[0])"
                                      [cdkDropListData]="cargoSpaceGroups(stop.cargoSpaces[0])"
                                      [cdkDropListDisabled]="isDragDisabledForCargoSpace(stop.cargoSpaces[0])"
                                      (cdkDropListDropped)="onDropped($event)"
                                      [attr.data-work-space-index]="i"
                                      [attr.data-cargo-space-index]="0"
                                      [attr.data-stop-index]="stopIndex"
                                      >
                                      <ng-container
                                        *ngTemplateOutlet="
                                          palletLayerGroupsTpl;
                                          context: {
                                            wsIndex: i,
                                            csIndex: 0,
                                            stopIndex: stopIndex,
                                            cargoSpace: workSpace.stops[stopIndex].cargoSpaces[0],
                                            lastGroupInList: listGroupsForCargoSpace(workSpace.stops[stopIndex].cargoSpaces[0]).length === 0
                                          }
                                        "
                                      ></ng-container>
                                      @for (
                                        group of listGroupsForCargoSpace(workSpace.stops[stopIndex].cargoSpaces[0]); track trackByFunction(groupIndexSemiTrailer,
                                        group); let groupIndexSemiTrailer = $index) {
                                        <gl-loads-list-element
                                          cdkDrag
                                          [cdkDragDisabled]="isGroupDragDisabled(stop.cargoSpaces[0])"
                                          (cdkDragStarted)="onDragStarted($event)"
                                          (cdkDragEnded)="onDragEnded()"
                                          [class.draggable]="isGroupDraggable(stop.cargoSpaces[0])"
                                          (editwindow)="onEditWindow($event)"
                                          [group]="group"
                                          [isSharedProjectLast]="isSharedProjectLast"
                                          [workSpaceIndex]="i"
                                          [stopIndex]="stopIndex"
                                          [cargoSpaceIndex]="0"
                                          [lastLoad]="false"
                                        ></gl-loads-list-element>
                                      }
                                    </div>
                                  </div>
                                @if (workSpace.stops[stopIndex].cargoSpaces[1]) {
                                  <div>
                                    <gl-loading-space-element
                                      [workSpace]="workSpace"
                                      [workSpaceIndex]="i"
                                      [cargoSpaceIndex]="1"
                                      [isClosed]="isClose(i)"
                                      (showLoads)="showLoads($event)"
                                    ></gl-loading-space-element>
                                    <div
                                      cdkDropList
                                      [cdkDropListData]="cargoSpaceGroups(workSpace.stops[stopIndex].cargoSpaces[1])"
                                      [cdkDropListDisabled]="isDragDisabledForCargoSpace(stop.cargoSpaces[1])"
                                      (cdkDropListDropped)="onDropped($event)"
                                      [attr.data-work-space-index]="i"
                                      [attr.data-cargo-space-index]="1"
                                      [attr.data-stop-index]="stopIndex"
                                      class="list"
                                      >
                                      <ng-container
                                        *ngTemplateOutlet="
                                          palletLayerGroupsTpl;
                                          context: {
                                            wsIndex: i,
                                            csIndex: 1,
                                            stopIndex: stopIndex,
                                            cargoSpace: workSpace.stops[stopIndex].cargoSpaces[1],
                                            lastGroupInList: listGroupsForCargoSpace(workSpace.stops[stopIndex].cargoSpaces[1]).length === 0
                                          }
                                        "
                                      ></ng-container>
                                      @for (
                                        group of listGroupsForCargoSpace(workSpace.stops[stopIndex].cargoSpaces[1]); track trackByFunction(groupIndexTrailer,
                                        group); let groupIndexTrailer = $index) {
                                        <gl-loads-list-element
                                          cdkDrag
                                          [cdkDragDisabled]="isGroupDragDisabled(stop.cargoSpaces[1])"
                                          (cdkDragStarted)="onDragStarted($event)"
                                          (cdkDragEnded)="onDragEnded()"
                                          [class.draggable]="isGroupDraggable(stop.cargoSpaces[1])"
                                          (editwindow)="onEditWindow($event)"
                                          [group]="group"
                                          [workSpaceIndex]="i"
                                          [stopIndex]="stopIndex"
                                          [isSharedProjectLast]="isSharedProjectLast"
                                          [cargoSpaceIndex]="1"
                                          [lastLoad]="false"
                                        ></gl-loads-list-element>
                                      }
                                    </div>
                                  </div>
                                }
                                <!-- Unloading space - always render for multi-stops to allow drag & drop, but hide visually if empty and not dragging -->
                                <div
                                  id="unloadingList"
                                  [style.display]="workSpace.stops[stopIndex].unloadingSpace.groups.length > 0 || grabbingWorkSpaceIndex === i || isDragging() ? 'block' : 'none'"
                                  >
                                  <div class="loadsTitle">
                                    <gl-icon class="arrowIcon arrowRotate" name="arrow"></gl-icon>
                                    <div>{{ 'loads_cargo_unloaded' | translate }}:</div>
                                  </div>
                                  <div
                                    cdkDropList
                                    [cdkDropListData]="workSpace.stops[stopIndex].unloadingSpace.groups"
                                    [cdkDropListDisabled]="dragDisabled"
                                    (cdkDropListDropped)="onDropped($event)"
                                    [attr.data-work-space-index]="i"
                                    [attr.data-is-unloading-space]="true"
                                    [attr.data-stop-index]="stopIndex"
                                    class="outside-list list unloaded"
                                    >
                                    @for (
                                      group of workSpace.stops[stopIndex].unloadingSpace.groups; track trackByFunction($index,
                                      group)) {
                                      <gl-loads-list-element
                                        cdkDrag
                                        [cdkDragDisabled]="isEdditing"
                                        (cdkDragStarted)="onDragStarted($event)"
                                        (cdkDragEnded)="onDragEnded()"
                                        [class.draggable]="!isEdditing"
                                        (editwindow)="onEditWindow($event)"
                                        [group]="group"
                                        [workSpaceIndex]="i"
                                        [isSharedProjectLast]="isSharedProjectLast"
                                        [stopIndex]="stopIndex"
                                        [isUnloadingSpace]="true"
                                        [attr.data-group-id]="group.id"
                                      ></gl-loads-list-element>
                                    }
                                  </div>
                                </div>
                                <div
                                  class="outside"
                                  [class.outsideHidden]="!(isEmptyStopCargoSpace(i, stopIndex) || grabbingWorkSpaceIndex === i || isDragging())"
                                  >
                                  <div class="listTitle stopTitle" [class.listTitleMobile]="isMobile">
                                    <h4 class="stopText">{{ 'loads_outside_space' | translate }}</h4>
                                    <gl-more-button (addLoads)="onAddLoadsToLoadingSpace(i, stopIndex)"
                                    (deleteAll)="onDeleteAllTheLoads(i, stopIndex)"
                                    [showAddLoads]="showAddToLoadingSpace()"></gl-more-button>
                                  </div>
                                  <div
                                    cdkDropList
                                    [cdkDropListData]="workSpace.stops[stopIndex].outsideSpace.groups"
                                    [cdkDropListDisabled]="dragDisabled || isOutsideDropDisabled(i)"
                                    (cdkDropListDropped)="onDropped($event)"
                                    [attr.data-work-space-index]="i"
                                    [attr.data-stop-index]="stopIndex"
                                    class="outside-list list"
                                    >
                                    @for (
                                      group of workSpace.stops[stopIndex].outsideSpace.groups; track trackByFunction($index,
                                      group)) {
                                      <gl-loads-list-element
                                        cdkDrag
                                        [cdkDragDisabled]="isOutsideGroupDragDisabled(group)"
                                        (cdkDragStarted)="onDragStarted($event)"
                                        (cdkDragEnded)="onDragEnded()"
                                        [class.draggable]="isOutsideGroupDraggable(group)"
                                        (editwindow)="onEditWindow($event)"
                                        [group]="group"
                                        [isSharedProjectLast]="isSharedProjectLast"
                                        [workSpaceIndex]="i"
                                        [isOutsideSpace]="true"
                                        [stopIndex]="stopIndex"
                                        [interactionDisabled]="isGroupInteractionLocked(group)"
                                        [attr.data-group-id]="group.id"
                                      ></gl-loads-list-element>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                    @if (workSpace.outsideSpace?.groups?.length > 0 && currentStopIndex === undefined) {
                      <div class="loadsTitle outsideTitle">
                        <div class="outsideTitleLeft">
                          <div class="outsideText">{{ 'outside_list' | translate }}</div>
                        </div>
                        @if(!isSharedView) {
                          <div class="outsideTitleRight">
                            <gl-more-button (addLoads)="onAddLoadsToLoadingSpace(i, undefined)"
                                            (deleteAll)="onDeleteAllTheLoads(i, undefined)"
                                            [showAddLoads]="showAddToLoadingSpace()"></gl-more-button>
                          </div>
                        }
                      </div>
                    }
                    @if (!isClose(i) && !isStop(workSpace)) {
                      <div
                        class="outside"
                        [class.outsideMargin]="workSpace.outsideSpace && workSpace.outsideSpace?.groups?.length === 0"
                        [class.outsideHidden]="!isEmptyCargoSpace(i) && grabbingWorkSpaceIndex !== i"
                        >
                        <div
                          cdkDropList
                          [cdkDropListData]="workSpace.outsideSpace.groups"
                          [cdkDropListDisabled]="dragDisabled || isOutsideDropDisabled(i)"
                          (cdkDropListDropped)="onDropped($event)"
                          [attr.data-work-space-index]="i"
                          class="outside-list list"
                          >
                          @for (
                            group of workSpaces[i].outsideSpace.groups; track trackByFunction(groupIndexOutside,
                            group); let groupIndexOutside = $index) {
                            <gl-loads-list-element
                              cdkDrag
                              [cdkDragDisabled]="isOutsideGroupDragDisabled(group)"
                              (cdkDragStarted)="onDragStarted($event)"
                              (cdkDragEnded)="onDragEnded()"
                              [class.draggable]="isOutsideGroupDraggable(group)"
                              (editwindow)="onEditWindow($event)"
                              [group]="group"
                              [isSharedProjectLast]="isSharedProjectLast"
                              [workSpaceIndex]="i"
                              [isOutsideSpace]="true"
                              [interactionDisabled]="isGroupInteractionLocked(group)"
                              [lastLoad]="groupIndexOutside === workSpaces[i].outsideSpace?.groups.length - 1"
                            ></gl-loads-list-element>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
